<template>
  <el-dialog
    v-if="showoff"
    :visible.sync="showoff"
    title="新增商品"
    width="700px"
  >
    <el-form ref="form" label-width="100px">
      <el-form-item label="新增方式">
        <el-radio-group v-model="typeVale" @change="changeType">
          <el-radio :label="1">直接新增</el-radio>
          <el-radio :label="2">根据商品ID复制信息后新增</el-radio>
          <el-input
            class="goods-id-input"
            v-model="goodsId"
            placeholder="请输入商品id"
            :disabled="typeVale === 1"
            @input="inputIds"
          ></el-input>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="关联供应商">
        <el-input
          v-model="relationSupplierId"
          placeholder="请输入供应商id"
        ></el-input>
      </el-form-item>
      <el-form-item label="铺品渠道">
        <el-checkbox-group v-model="qudaoType">
          <el-checkbox disabled :label="1">农博优选</el-checkbox>
          <el-radio-group v-model="yxIsOnSale">
            <el-radio :label="1"
              >上架<span style="color: red"
                >（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）</span
              ></el-radio
            >
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
          <el-checkbox :label="2">渠道选品中心</el-checkbox>
          <el-checkbox :label="3"
            >ERP<span style="color: red"
              >（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）</span
            ></el-checkbox
          >
          <el-checkbox :label="4">中国土特产</el-checkbox>
          <el-radio-group :disabled="!qudaoType.includes(4)" v-model="ttcIsOnSale">
            <el-radio :label="1"
              >上架<span style="color: red"
                >（若商品未关联供应商，订单由农博优选店发货，请谨慎操作）</span
              ></el-radio
            >
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-checkbox-group>
      </el-form-item>
    </el-form>

    <div class="btn-box">
      <el-button type="primary" @click="submitBtn">确定</el-button>
      <el-button @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { inNum } from "@/com.js";

export default {
  data() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    return {
      showoff: false,
      relationSupplierId: "",
      typeVale: 1,
      goodsId: "",
      qudaoType: [1],
      yxIsOnSale: 1,
      ttcIsOnSale: 1,
    };
  },
  methods: {
    show() {
      this.showoff = true;
    },
    close() {
      this.showoff = false;
    },
    changeType(val) {
      if (val === 1) this.goodsId = "";
    },
    async submitBtn() {
      const { storeList, suppliersId } = this.userInfo;
      const storeId =
        storeList && storeList[0]
          ? storeList[0].storeId
          : localStorage.getItem("defaultStoreId");
      const query = {
        storeId,
        suppliersId,
        goodsBuyType: "0",
        from: "addgyl",
        yxIsOnSale: this.yxIsOnSale,
        scIsOnSale: this.qudaoType.includes(2) ? 1 : 0,
        syncErp: this.qudaoType.includes(3) ? 1 : 0,
      };
      this.qudaoType.includes(4) && (query.ttcIsOnSale = this.ttcIsOnSale);

      if (this.typeVale === 2) {
        if (!this.goodsId) {
          this.$message({ type: "error", message: "请输入商品id" });
          return;
        }
      }

      const params2 = {};
      if (this.goodsId) params2.goodsId = this.goodsId;
      if (this.relationSupplierId) {
        params2.relationSupplierId = this.relationSupplierId;
        query.relationSupplierId = this.relationSupplierId;
      }
      if (this.goodsId || this.relationSupplierId) {
        const res = await this.$axios.post(
          this.$api.goodsmanage.checkBeforeAdd,
          params2
        );
        if (res.code !== 0) return;

        const { relationSupplierName } = res.data || {};
        if (relationSupplierName)
          query.relationSupplierName = relationSupplierName;
      }

      if (this.typeVale === 2) {
        const params = { id: this.goodsId, type: 1 };
        const result = await this.$axios.get(
          this.$api.goodsmanage.trade_goods_detail,
          { params }
        );
        if (result.code !== 0) return;

        const { tradeGoodsDto } = result.data || {};

        if (!tradeGoodsDto || tradeGoodsDto.ancestryCategoryId !== "1") {
          this.$message({
            type: "error",
            message: "仅支持农副产品商品复制后新增",
          });
          return;
        }

        query.activeSteps = 1;
        query.goodsType = 1;
        query.type = "edit";
        query.goodsId = this.goodsId;
        query.backendCategoryId = tradeGoodsDto.backendCategoryId;
      }

      const route = this.$router.resolve({ path: "/nb/goods/add", query });
      window.open(window.location.origin + route.href);
    },
    inputIds(val) {
      this.goodsId = inNum(val, { zero: false, limit: 0 });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-radio-group {
  display: flex;
  flex-direction: column;
  ::v-deep(.el-radio) {
    margin-bottom: 10px;
  }
}
.goods-id-input {
  width: 300px;
}
</style>
